<template>
  <div :class="[ 'general-container', mainClass ]">
    <div class="general-container__title">
      <div class="general-container__title-picture title-picture">
        <MediaImage class="title-picture__media" uuid="319556c0-7720-48d7-8711-1c1351edbded" width="48" height="48" />
      </div>
      <div class="general-container__title-text">
        <span class="general-container__title-main">{{ title }}<span v-if="titlePrecision">{{ titlePrecision }}</span></span>
        <span class="general-container__subtitle">
          {{
            trans('guided_search.general.subtitle', {
              company_name: $companyName,
            })
          }}
        </span>
      </div>
    </div>
    <slot name="content" />
  </div>
</template>

<script>
import MediaImage from '@components/MediaImage.vue';
import { translationMixin } from '@tools/translation';
import { guidedSearchMixin } from '@pages/guided-search/guidedSearchMixin';

export default {
  components: { MediaImage },
  mixins: [ guidedSearchMixin, translationMixin ],
  props: {
    title: { type: String, required: true },
    titlePrecision: { type: String, default: '' },
    mainClass: { type: String, required: true }, // mainClass is the class for the block inserted there
  },
};
</script>
